import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const ErrorIcon = props => /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 22 22",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.99 10.995c0 6.004-4.98 10.994-10.995 10.994C4.99 21.99 0 17 0 10.995 0 4.98 4.98 0 10.984 0c6.014 0 11.005 4.98 11.005 10.995Zm-11.879 1.12c.011.572.324.884.884.884.54 0 .852-.301.863-.883l.15-5.864c.011-.571-.43-.992-1.023-.992-.604 0-1.025.41-1.014.981l.14 5.875Zm-.323 3.342c0 .636.56 1.153 1.207 1.153s1.208-.506 1.208-1.153-.55-1.164-1.208-1.164c-.657 0-1.207.528-1.207 1.164Z",
    clipRule: "evenodd"
  })
});
export default ErrorIcon;